module.exports = __webpack_public_path__ + "media/images/sp/articles/recommend_03-bfb0d68e0bd31f18eda4533cb5515622.webp";